/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import {
  IconChevronDown,
  IconChevronUp,
  IconCloudUpload,
  IconDeviceFloppy,
  IconEdit,
  IconLoader2,
} from "@tabler/icons-react";
import { useClientProfileData, useProfileData, useUpdateProfile } from "../../apis/profileApis";
import Input from "../../components/Input";
import { useForm, Controller } from "react-hook-form";
import toast from "react-hot-toast";
// import Configuration from "./_components/Configuration";
import Password from "./_components/Password";
import { getFileExtension } from "../../utilities/helper";

type InputProps = {
  label?: string;
  value: string;
  editable: boolean;
  className?: string;
};

const InputField = ({ label, value, editable, className = "" }: InputProps) => (
  <div className={`flex justify-between items-center space-y-4 ${className}`}>
    {label && (
      <label className="w-full text-base text-[#212121]">{label}</label>
    )}
    <input
      type="text"
      value={value}
      disabled={!editable}
      className={`px-4 py-2 text-sm w-full rounded-full outline-none ${editable
        ? "bg-white border border-[#D8D8D8]"
        : "bg-[#F2F2F2] border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
        }`}
    />
  </div>
);

const UploadButton = ({
  label,
  onClick,
}: {
  label: string;
  onClick?: () => void;
}) => (
  <button
    type="button"
    onClick={onClick}
    className="flex items-center justify-center py-[7px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
  >
    <IconCloudUpload stroke={1} size={20} />
  </button>
);

type FormValues = {
  companyName: string;
  contactPerson: string;
  crNumber: string;
  vatNumber: string;
  systemMail: string;
  warehouse: string;
  email: string;
  mobileNo: string;
  district: string;
  city: string;
  // zipCode: string;
  clientAddress: string;
  lmAwbNumber: string;
  shortAddress: string;
  tollFreeNo: string;
  crCopy: File;
  vatDocument: File;
  country?: string
  // companyLogo: File | null;
};

export default function Profile() {
  const [isEdit, setIsEdit] = useState(false);
  const [openSection, setOpenSection] = useState<string | null>("profile");

  // toggle handler
  const toggleSection = (section: string) => {
    setOpenSection((prev) => (prev === section ? null : section));
  };
  const { data, refetch } = useClientProfileData();
  const { mutate, isPending } = useUpdateProfile();
  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm<FormValues>();

  useEffect(() => {
    if (data) {
      // setValue("companyLogo", data?.logoUrl);
      setValue("companyName", data?.name ?? data?.storeName);
      setValue("contactPerson", data?.contactPerson);
      setValue("email", data?.email);
      setValue("systemMail", data?.systemMail);
      setValue("lmAwbNumber", data?.lmAwbNumber);
      setValue("mobileNo", data?.mobileNo);
      setValue("systemMail", data?.systemMail);
      setValue("crNumber", data?.crNumber);
      setValue("vatNumber", data?.vatNumber);
      setValue("crCopy", data?.crCopy);
      setValue("vatDocument", data?.vatDocument);
      setValue("country", data?.country)
      setValue("warehouse", data?.warehouse);
      setValue("district", data?.district);
      setValue("city", data?.city);
      setValue("clientAddress", data?.clientAddress);
      // setValue("zipCode", data?.zipCode);
      setValue("tollFreeNo", data?.tollFreeNo);
      setValue("shortAddress", data?.shortAddress);
    }
  }, [data]);

  const fileInputRefs = {
    // companyLogo: useRef<HTMLInputElement>(null),
    vatDocument: useRef<HTMLInputElement>(null),
    crCopy: useRef<HTMLInputElement>(null),
  };

  const handleFileUploadClick = (fieldName: keyof typeof fileInputRefs) => {
    fileInputRefs[fieldName].current?.click();
  };

  const onSubmit = (data: any) => {
    console.log("Form submitted:", data);
    // setIsEdit(false);
    // reset();
    mutate(
      { ...data },
      {
        onSuccess: (data: any) => {
          reset();
          refetch();
          setIsEdit(!isEdit);
          toast.success("Profile Update Successfully.");
        },
        onError: (error: any) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      }
    );
    // Handle form submission here
  };

  return (
    <div className="w-[1280px] mx-auto text-[#1E293B] space-y-4 pb-4">
      <div className="flex justify-between items-center">
        <p className="text-2xl text-[#212121] tracking-[-0.5px]">
          Company Information
        </p>
      </div>
      <input
        type="file"
        accept=".pdf,.doc,.docx"
        ref={fileInputRefs.vatDocument}
        className="hidden"
      />
      <input
        type="file"
        accept=".pdf,.doc,.docx"
        ref={fileInputRefs.crCopy}
        className="hidden"
      />

      <div className="border border-[#d2d2d2] rounded-[20px] p-4 bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] space-y-4">
        <div
          onClick={() => toggleSection("profile")}
          className="flex justify-between items-center cursor-pointer"
        >
          <h2 className="uppercase font-medium text-base text-[#212121]">
            Profile Details
          </h2>
          {openSection === "profile" ? (
            <IconChevronUp size={22} stroke={1.5} color="#6B7280" />
          ) : (
            <IconChevronDown size={22} stroke={1.5} color="#6B7280" />
          )}
        </div>
        {openSection === "profile" && (
          <>
            <div className="grid grid-cols-6 gap-4">
              <Input
                name="companyName"
                type="text"
                title="Company Name"
                placeholder=" "
                register={register}
                error={errors.companyName}
                validation={{ required: "Company Name is required" }}
                className="col-span-3"
                inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                  ? "bg-white border border-[#D8D8D8]"
                  : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                  }`}
                disabled={!isEdit}
              />
              <Input
                name="contactPerson"
                type="text"
                title="Contract Person"
                placeholder="Enter Name"
                register={register}
                error={errors.contactPerson}
                validation={{ required: "Contact Person is required" }}
                className="col-span-3"
                inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                  ? "bg-white border border-[#D8D8D8]"
                  : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                  }`}
                disabled={!isEdit}
              />
              <Input
                name="email"
                type="text"
                title="Mail Address"
                placeholder="Enter Email Address"
                register={register}
                error={errors.email}
                validation={{ required: "Email is required" }}
                className="col-span-3"
                inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                  ? "bg-white border border-[#D8D8D8]"
                  : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                  }`}
                disabled={true}
              />
              <Input
                name="mobileNo"
                type="number"
                title="Mobile Number"
                placeholder="Enter Mobile Number"
                register={register}
                error={errors.mobileNo}
                validation={{ required: "Mobile Number is required" }}
                className="col-span-3"
                inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                  ? "bg-white border border-[#D8D8D8]"
                  : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                  }`}
                disabled={true}
              />
              {watch('warehouse') && (
                <Input
                  name="warehouse"
                  type="text"
                  title="Warehouse"
                  placeholder=" "
                  register={register}
                  error={errors.warehouse}
                  validation={{ required: "Warehouse is required" }}
                  className="col-span-2"
                  inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                    ? "bg-white border border-[#D8D8D8]"
                    : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                    }`}
                  disabled={true}
                />
              )}

              {watch('country') && (
                <Input
                  name="country"
                  type="text"
                  title="Country"
                  placeholder=" "
                  register={register}
                  error={errors.country}
                  validation={{ required: "Country is required" }}
                  className="col-span-2"
                  inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                    ? "bg-white border border-[#D8D8D8]"
                    : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                    }`}
                  disabled={true}
                />
              )}
              <Input
                name="city"
                type="text"
                title="City"
                placeholder=" "
                register={register}
                error={errors.city}
                validation={{ required: "City is required" }}
                className="col-span-2"
                inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                  ? "bg-white border border-[#D8D8D8]"
                  : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                  }`}
                disabled={true}
              />
              <Input
                name="district"
                type="text"
                title="District"
                placeholder=" "
                register={register}
                error={errors.district}
                validation={{ required: "State is required" }}
                className="col-span-2"
                inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                  ? "bg-white border border-[#D8D8D8]"
                  : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                  }`}
                disabled={true}
              />
              <Input
                name="shortAddress"
                type="text"
                title="Short Address"
                placeholder=" "
                register={register}
                className="col-span-3"
                inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                  ? "bg-white border border-[#D8D8D8]"
                  : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                  }`}
                disabled={!isEdit}
              />
              {/* <Input
                name="zipCode"
                type="text"
                title="Postal / ZIP Code"
                placeholder=" "
                register={register}
                error={errors.zipCode}
                validation={{ required: "Postal / ZIP Code is required" }}
                className="col-span-3"
                inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
                  isEdit
                    ? "bg-white border border-[#D8D8D8]"
                    : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                }`}
                disabled={!isEdit}
              /> */}
            </div>
            <div className="divide-x divide-[#d2d2d2] grid grid-cols-1 gap-4">
              <div className="space-y-4 pr-4">
                <h2 className="uppercase font-medium text-sm text-[#212121]">
                  Document
                </h2>
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-1">
                    <label className="text-sm text-[#1E293B]">
                      VAT Percent & Number
                    </label>
                    <div className="flex items-center w-full gap-2 mb-3">
                      <Input
                        name="vatNumber"
                        type="number"
                        placeholder=""
                        register={register}
                        error={errors.vatNumber}
                        validation={{
                          validate: (value: string) => {
                            const trimmed = value?.trim();
                            if (trimmed && trimmed.length !== 15) {
                              return "Tax/VAT number must be 15 digits";
                            }
                            return true;
                          },
                        }}
                        className="w-full"
                        labelClass="text-sm text-[#1E293B]"
                        inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                          ? "bg-white border border-[#D8D8D8]"
                          : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                          }`}
                        disabled={!isEdit}
                      />

                      <Controller
                        control={control}
                        name="vatDocument"
                        rules={{
                          validate: (file: File) => {
                            const vatNumber = watch("vatNumber")
                              ?.toString()
                              .trim();
                            if (vatNumber && !file)
                              return "Please select a file";
                            if (file) {
                              const allowedTypes = [
                                "image/jpeg",
                                "image/png",
                                "image/jpg",
                                "application/pdf",
                              ];
                              if (
                                file.type
                                  ? !allowedTypes.includes(file.type)
                                  : !["jpeg", "png", "jpg", "pdf"].includes(
                                    getFileExtension(file as any)
                                  )
                              ) {
                                return "Only JPG, JPEG, PDF, or PNG files are allowed";
                              }
                            }
                            return true;
                          },
                        }}
                        render={({ field, fieldState }) => (
                          <div>
                            <input
                              type="file"
                              id="vat-doc"
                              className="hidden"
                              onChange={(e) => {
                                const file = e.target.files?.[0];
                                if (file) field.onChange(file);
                              }}
                            />
                            {field.value && !isEdit ? (
                              // OPEN in new tab instead of direct download
                              <a
                                href={
                                  field.value instanceof File
                                    ? URL.createObjectURL(field.value)
                                    : field.value // URL string from backend
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center justify-center py-[10px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
                              >
                                <img src="\img\download-file-icon.svg" alt="" />
                              </a>
                            ) : (
                              <label
                                htmlFor="vat-doc"
                                className="flex items-center justify-center py-[7px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
                              >
                                <IconCloudUpload stroke={1} size={20} />
                              </label>
                            )}
                            {fieldState.error && (
                              <p className="text-red-500 text-sm mt-1">
                                {fieldState.error.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                  </div>
                  <div className=" space-y-1">
                    <label className="text-sm text-[#1E293B]">CR Number</label>
                    <div className="w-full flex items-center gap-2">
                      <Input
                        name="crNumber"
                        type="number"
                        placeholder=""
                        register={register}
                        error={errors.crNumber}
                        validation={{
                          required: "CR Number is required",
                          validate: (value: string) => {
                            const trimmed = value.trim();
                            if (trimmed.length !== 10)
                              return "CR number must be 10 numbers";
                            return true;
                          },
                        }}
                        className="w-full"
                        inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${isEdit
                          ? "bg-white border border-[#D8D8D8]"
                          : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                          }`}
                        disabled={!isEdit}
                      />

                      <Controller
                        control={control}
                        name="crCopy"
                        rules={{
                          required: "File is required",
                          validate: (file: File) => {
                            if (!file) return "Please select a file";
                            const allowedTypes = [
                              "image/jpeg",
                              "image/png",
                              "image/jpg",
                              "application/pdf",
                            ];
                            if (
                              file.type
                                ? !allowedTypes.includes(file.type)
                                : !["jpeg", "png", "jpg", "pdf"].includes(
                                  getFileExtension(file as any)
                                )
                            ) {
                              return "Only JPG, JPEG, PDF, or PNG allowed";
                            }
                            return true;
                          },
                        }}
                        render={({ field, fieldState }) => (
                          <div>
                            <input
                              type="file"
                              id="cr-doc"
                              className="hidden"
                              onChange={(e) => {
                                const file = e.target.files?.[0];
                                if (file) field.onChange(file);
                              }}
                            />
                            {field.value && !isEdit ? (
                              <a
                                href={
                                  field.value instanceof File
                                    ? URL.createObjectURL(field.value)
                                    : field.value
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center justify-center py-[10px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
                              >
                                <img src="\img\download-file-icon.svg" alt="" />
                              </a>
                            ) : (
                              <label
                                htmlFor="cr-doc"
                                className="flex items-center justify-center py-[7px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
                              >
                                <IconCloudUpload stroke={1} size={20} />
                              </label>
                            )}
                            {fieldState.error && (
                              <p className="text-red-500 text-sm mt-1">
                                {fieldState.error.message}
                              </p>
                            )}
                          </div>
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="space-y-4 pl-4">
                <h2 className="uppercase font-medium text-sm text-[#212121]">
                  AWb Info
                </h2>
                <div className="grid grid-cols-2 gap-4">
                  <Input
                    name="lmAwbNumber"
                    type="text"
                    title="Fulfillment"
                    placeholder=""
                    register={register}
                    inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
                      isEdit
                        ? "bg-white border border-[#D8D8D8]"
                        : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                    }`}
                    disabled={true}
                  />
                  <Input
                    name="lmAwbNumber"
                    type="text"
                    title="Lastmiles"
                    placeholder=""
                    register={register}
                    inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
                      isEdit
                        ? "bg-white border border-[#D8D8D8]"
                        : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                    }`}
                    disabled={true}
                  />
                  <Input
                    name="tollFreeNo"
                    type="number"
                    title="AWB Toll Free No"
                    placeholder=""
                    register={register}
                    inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
                      isEdit
                        ? "bg-white border border-[#D8D8D8]"
                        : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                    }`}
                    disabled={!isEdit}
                  />
                  <Input
                    name="systemMail"
                    type="email"
                    title="Info Email"
                    placeholder=""
                    register={register}
                    error={errors.systemMail}
                    validation={{ required: "Info Email is required" }}
                    inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
                      isEdit
                        ? "bg-white border border-[#D8D8D8]"
                        : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
                    }`}
                    disabled={!isEdit}
                  />
                </div>
              </div> */}
            </div>
            <div className="pt-4">
              <button
                type={isEdit ? "submit" : "button"}
                onClick={() => {
                  isEdit ? handleSubmit(onSubmit)() : setIsEdit(!isEdit);
                }}
                className="bg-[#FBD037] text-[#212121] text-base font-semibold  p-2.5 rounded-full"
              >
                {isPending ? (
                  <IconLoader2 className="animate-spin" />
                ) : isEdit ? (
                  <IconDeviceFloppy />
                ) : (
                  <IconEdit />
                )}
              </button>
            </div>
          </>
        )}
      </div>

      {/* <div className="border border-[#d2d2d2] rounded-[20px] p-4 bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]  space-y-4">
        <div
          onClick={() => toggleSection("config")}
          className="flex justify-between items-center cursor-pointer"
        >
          <h2 className="uppercase font-medium text-base text-[#212121]">
            Configuration
          </h2>
          {openSection === "config" ? (
            <IconChevronUp size={22} stroke={1.5} color="#6B7280" />
          ) : (
            <IconChevronDown size={22} stroke={1.5} color="#6B7280" />
          )}
        </div>
        {openSection === "config" && <Configuration />}
      </div> */}
      <div className="border border-[#d2d2d2] rounded-[20px] p-4 bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]  space-y-4">
        <div
          onClick={() => toggleSection("resetPassword")}
          className="flex justify-between items-center cursor-pointer"
        >
          <h2 className="uppercase font-medium text-base text-[#212121]">
            Reset Password
          </h2>
          {openSection === "resetPassword" ? (
            <IconChevronUp size={22} stroke={1.5} color="#6B7280" />
          ) : (
            <IconChevronDown size={22} stroke={1.5} color="#6B7280" />
          )}
        </div>
        {openSection === "resetPassword" && <Password />}
      </div>
    </div>
  );
}
